import { CreditCardFastIcon } from './CreditCardFastIcon';

/**
 * author: Jeff Anders
 * id 896151D2-B1B7-42C5-95E7-78517BEC5676
 * name credit-card-fast
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/credit-card-fast.svg
 * tags
 * - Banking 
 */
export const CreditCardSwipeIcon = CreditCardFastIcon;
export default CreditCardSwipeIcon